<template>
  <form class="has-background-white">
    <div class="is-padding">
      <div
        v-if="!sourceAccount"
        class="columns is-margin-bottom-small">
        <div class="column">
          <div class="title is-4">
            <b>Création d'un mandat sur ce {{ nameToUse }}</b>
          </div>
        </div>
      </div>
      <div
        v-if="!program"
        class="columns is-margin-bottom-small">
        <div class="column is-6 is-paddingless-top">
          <div class="field">
            <r-label
              :is-required="false"
              :label="'Programmes'"
              :value="programsChoosen"></r-label>
            <div v-if="sourceProgramsAccess || programsAccess">
              <multiselect
                v-model="programsChoosen"
                :options="sourceProgramsAccess || programsAccess"
                :multiple="true"
                class="multiselect--option-ico"
                :searchable="true"
                value="pk"
                :placeholder="''"
                name="programs"
                :disabled="all_programs"
                v-validate="requiredPrograms"
                data-vv-as="Programmes"
                :close-on-select="false"
                :show-labels="false"
                label="name"
                track-by="pk"
                @search-change="getPrograms">
                <span slot="noResult">Oups! Aucun programme trouvé.</span>
                <span
                  slot="placeholder"
                  class="multiselect__placeholder">Sélectionnez ou saisissez un ou plusieurs programme(s)</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
              <p
                v-if="errors.has('programs')"
                class="help is-danger">
                {{ errors.first('programs') }}
              </p>
            </div>
          </div>
        </div>
        <div class="column columns is-column is-gapless is-space-around is-marginless">
          <r-label
            :is-required="false"
            :label="'Sélectionnez tous les programmes'"
            :value="all_programs"></r-label>
          <div>
            <input
              id="all_programs"
              type="checkbox"
              name="all_programs"
              class="switch is-success is-success is-rounded is-large"
              v-model="all_programs">
            <label
              for="all_programs"
              class="is-paddingless-top is-uppercase"><span class="is-size-6 is-padding-top-xsmall">{{ sourceProgramsAccessCount || programsAccessCount }} programme(s)</span></label>
          </div>
        </div>
      </div>
      <div
        v-if="!sourceAccount"
        class="field columns">
        <div class="control column is-6 is-margin-bottom-small is-paddingless-top">
          <r-label
            :is-required="false"
            :label="'Société'"
            :value="accountsChoosen"></r-label>
          <multiselect
            id="quickvSearchStates"
            class="multiselect--option-ico"
            name="referent-user"
            v-model="accountsChoosen"
            :options="items"
            :multiple="true"
            :searchable="true"
            :close-on-select="false"
            :show-labels="false"
            group-values="users"
            group-label="name"
            :group-select="true"
            :placeholder="''"
            :custom-label="v => `${v.label}`"
            track-by="value">
            <span
              slot="placeholder"
              class="multiselect__placeholder">Sélectionnez ou saisissez votre société</span>
            <span slot="noOptions">La liste est vide</span>
          </multiselect>
        </div>
        <div class="column columns is-column is-gapless is-space-around is-marginless">
          <r-label
            :is-required="false"
            :label="'Toutes les sociétés'"
            :value="all_accounts"></r-label>
          <div>
            <input
              id="all_accounts"
              type="checkbox"
              name="all_accounts"
              class="switch is-success is-success is-rounded is-large"
              v-model="all_accounts">
            <label
              for="all_accounts"
              class="is-paddingless-top is-uppercase"><span class="is-size-6 is-padding-top-xsmall">{{ accountsAccessCount || accountsAccess.length }} société(s)</span></label>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12 is-5-widescreen is-4-fullhd">
          <div class="title is-5 has-text-weight-bold is-margin-bottom-xsmall">
            Date d'ouverture et de clôture
            <span class="is-margin-left-xsmall icon is-medium">&nbsp;</span><!-- Laisser cette ligne pr garantir un bon alignement -->
          </div>
          <div class="field">
            <date-picker
              :model="{start_date: access.start_date, end_date: access.end_date}"
              :is-range="true"
              :name="'date'"
              data-vv-as="Date d'ouverture et de clôture"
              :v-validate="'required'"
              :is-required="false"
              :style-version="2"
              :config="{mode: 'range'}"
              @input="Object.assign(access, $event)"></date-picker>
            <p
              v-if="errors.has('date')"
              class="help is-danger">
              {{ errors.first('date') }}
            </p>
          </div>
        </div>
        <div class="column is-12 is-7-widescreen is-8-fullhd">
          <div class="title is-5 has-text-weight-bold is-margin-bottom-xsmall">
            Taux de rémunération appliqué au mandat
            <span
              class="is-margin-left-xsmall icon is-medium"
              v-helper.bottom.small="'TB0OoATNl7Az15AJdBqQ6'">
              <i class="fal fa-question-circle has-text-grey"></i>
            </span>
          </div>
          <div class="columns">
            <div class="column is-4 is-3-widescreen">
              <input
                class="vadCheckradiocase is-primary is-fullwidth"
                id="remProgramme"
                type="radio"
                name="remProgramme"
                :value="REMUNERATION_MODES.PROGRAM"
                v-model="remunerationMode">
              <label
                class="has-text-weight-light"
                for="remProgramme"
                style="text-transform: capitalize">{{ nameToUse }}</label>
            </div>
            <div
              class="column is-4 is-3-widescreen"
              v-if="remunerationMode !== REMUNERATION_MODES.CUSTOM">
              <input
                class="vadCheckradiocase is-primary is-fullwidth"
                id="remCustom"
                type="radio"
                name="remCustom"
                :value="REMUNERATION_MODES.CUSTOM"
                v-model="remunerationMode">
              <label
                class="has-text-weight-light"
                for="remCustom">Taux spécifique</label>
            </div>
            <div
              v-else
              class="column is-4">
              <v-input
                :name="'remunerationInput'"
                :classes-input="'vadCheckradiocase is-active is-input is-fullwidth'"
                :has-incrementations="true"
                input-type="number"
                @input="val => updateRem(val)"
                :model="access.remuneration"
                :has-addons="true"
                :max="100"
                :step="1"
                :number="true"
                :errors-bag="errors"
                data-vv-value-path="val"
                ref="custominputParent"
                :reference="'custominput'"
                data-vv-as="remunerationInput">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-grey is-square is-static">
                    <span class="icon"><i class="fas fa-percentage"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
            <div
              v-if="isAdmin && program"
              class="column is-self-flex-start is-padding-bottom">
              <a
                class="button is-fullwidth is-transform-none"
                @click="openQuickView">
                <span class="icon is-small"><i class="fal fa-tasks"></i></span>
                <span>{{ allotments && allotments.length ? 'Modifier' : 'Créer un' }} allotement</span>
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="(allotments && allotments.length) || (newAllotments && newAllotments.length)"
          class="column is-paddingless-top is-7 is-6-fullhd">
          <p class="has-text-grey is-size-6 has-text-weight-medium is-margin-bottom-small">
            Allotement. Seul ces lots sont visibles par la société
            <span
              class="is-size-3 is-margin-left-xsmall icon is-small"
              v-helper.bottom.small="'5rjhlxyfy5cAa6qzQs4kVz'">
              <i class="fal fa-question-circle fa-xs has-text-grey"></i>
            </span>
          </p>
          <div class="tags">
            <template v-if="!newAllotments && allotments">
              <span
                v-for="allotment in allotments"
                :key="allotment.pk"
                class="tag is-allotement is-margin-right-xsmall is-normal is-wAuto">
                {{ allotment.ref || allotment.lot.ref }}
              </span>
            </template>
            <template v-else-if="newAllotments">
              <span
                v-for="newAllotment in newAllotments"
                :key="newAllotment.pk"
                class="tag is-allotement is-margin-right-xsmall is-normal is-wAuto">
                {{ newAllotment.ref }}
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="has-background-warning columns is-gapless is-vcentered">
      <div class="column is-narrow is-padding-small">
        <a class="button is-circle is-static is-medium">
          <i class="fal fa-lightbulb-on fa-lg"></i>
        </a>
      </div>
      <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-small">
        <div class="is-italic is-size-6">
          <b class="is-uppercase">Le taux {{ nameToUse }} : </b>
          <span>est le taux de rémunération précisé sur le {{ nameToUse }}</span>
        </div>
        <div class="is-italic is-size-6">
          <b class="is-uppercase">Taux spécifique : </b>
          <span> vous définissez un taux libre et spécifique qui va s'appliquer à la ou les société(s) pour ce(s) {{ nameToUse }}(s)</span>
        </div>
      </div>
    </div>
    <submit-sticky-buttons
      @submit="submit"
      :loading="submitLoading"
      button-id="accessForm"></submit-sticky-buttons>
  </form>
</template>

<script>
import { DefaultValues, Quickview, Access, GenericList } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'AccessForm',
  mixins: [DefaultValues, Quickview, Access, GenericList],
  props: {
    accessPk: {
      type: String
    },
    sourceAccess: {
      type: Object
    },
    sourceProgramsAccess: {
      type: Array
    },
    sourceAccountsAccess: {
      type: Array
    },
    sourceProgramsAccessCount: {
      type: [Number, String]
    },
    sourceAccountsAccessCount: {
      type: [Number, String]
    },
    program: {
      type: Object
    },
    account: {
      type: Object
    },
    sourceProgramLots: {
      type: Array
    },
    sourceAccount: {
      type: String
    }
  },
  data () {
    return {
      loadDocuments: this.loadItems,
      service: 'GROUP',
      query: {
        is_commercial: 0
      }
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    }
  },
  watch: {
    items (v) {
      if (v && v.length && v[0].created_on) {
        this.items = v.map(group => {
          if (group.users && group.users.length && group.users[0].account) {
            group.users = group.users.map(user => {
              return {
                label: user.account.name,
                value: user.account.pk,
                pk: user.account.pk
              }
            })
          }
          return {
            name: group.name,
            pk: group.pk,
            users: group.users
          }
        })
      }
    }
  },
  created () {
    if (this.$route.name === 'coucou') {
      // changer condition si on veux groupe interne
      // actuellement inutile dans ce composant
      this.query.is_commercial = 0
    } else {
      this.query.is_commercial = 1
    }
  }
}
</script>
